import { ExpressionColors, MessageConfigData, PostConfigData } from "./Party/PartyConfigData";

export type UserActionType = 'share';

export type UserAction = {
  actionType: UserActionType;
  config: PostConfigData;
  created: number;
  completed?: number;
}

export type UserSubmission = {
  itemId: string;
  actionId: string;
  submitted: number;
}

export type UserMessageInstance = {
  time: number;
  message: MessageConfigData;
}

export type CognitoAuthProvider = 'Cognito' | 'Fanbox' | 'none' | 'Google';

export type CognitoIdentity = {
  id: string;
  email: string;
  nickname: string;
  accessToken: string;
  provider: CognitoAuthProvider;
};

export const EmptyUserData = (userid: string): UserData => {
  return {
    fanbox: { id: userid },
    messages: {},
    actions: [],
    userInformation: {
      nickname: '@anon',
      displayColor: ExpressionColors[0],
      displayIcon: '',
      email: '',
      emailVerified: false,
      signUpComplete: false
    },
    submissions: [],
    accountInformation: {
      boostBalance: 0,
      fandomPoints: 0,
    },
    interests: {}
  };
}

export const EmptyCognitoIdentity = (): CognitoIdentity => {
  return {
    id: crypto.randomUUID(),
    nickname: "@anon",
    email: '',
    accessToken: 'INVALID',
    provider: 'none'
  }
}

export type FanboxIdentity = {
  id: string;
  accessToken?: string;
}

export type UserInformation = {
  nickname: string;
  email: string;
  emailVerified: boolean;
  displayColor: string;
  displayIcon: string;
  signUpComplete: boolean;
}

export type AccountInformation = {
  boostBalance: number;
  fandomPoints: number;
}

export type InterestProfileType = 'kvp' | 'vector' | 'matrix';
export type InterestProfile = {
  id: string;
  profileType: InterestProfileType,
  kvps: { [key: string]: number };
  enumerations: { [key: string]: { index: number, value: string }[] };
  metricNames: string[],
  metricNames2: string[],
  vector: number[];
  matrix: number[][];
}

export type SignUpData = {
  nickname : string;
  email : string;
  termsAccepted : boolean;
}

export type UserData = {
  cognito?: CognitoIdentity;
  fanbox: FanboxIdentity;
  userInformation: UserInformation;
  accountInformation: AccountInformation;
  messages: { [key: string]: UserMessageInstance[] };
  actions: UserAction[];
  submissions: UserSubmission[];
  interests: { [key: string]: InterestProfile }
}